exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-collapse-tl .card .card-content .field .input {\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  border-bottom: 1pt solid #C4C9CE;\n  border-radius: 0;\n  height: 24px;\n  font-size: 12px;\n}\n.list-collapse-tl .card .card-content .field .has-icons-left .is-left {\n  height: 23px;\n  width: 23px;\n}\n.list-collapse-tl .card .card-content .field .has-icons-left .is-left .mdi:before {\n  font-size: 18px;\n}", ""]);

// exports
